import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { InformationCircleIcon } from '@heroicons/react/24/solid';

const ProgressDialog = () => {
    const [progress, setProgress] = useState(0);
    const totalSeconds = 120; // 2 minutes

    useEffect(() => {
        const timer = setInterval(() => {
            setProgress((prevProgress) => {
                const newProgress = prevProgress + 1;
                if (newProgress >= totalSeconds) {
                    clearInterval(timer);
                }
                return newProgress;
            });
        }, 1000);

        return () => {
            clearInterval(timer);
        };
    }, []);

    // Calculate progress percentage, but cap at 90% for the timer
    const progressPercentage = Math.min((progress / totalSeconds) * 100, 90);

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-8 rounded-lg shadow-xl max-w-md w-full">
                <div className="flex items-center mb-4">
                    <InformationCircleIcon className="h-6 w-6 text-blue-500 mr-2" />
                    <h3 className="text-2xl font-bold">Generating Report</h3>
                </div>
                <p className="mb-4">Report takes around 2 minutes to generate</p>
                <div className="w-full h-4 bg-gray-200 rounded-full overflow-hidden">
                    <motion.div 
                        className="h-full bg-blue-500"
                        initial={{ width: 0 }}
                        animate={{ width: `${progressPercentage}%` }}
                        transition={{ duration: 0.5 }}
                    />
                </div>
                <p className="mt-2 text-sm text-gray-600">
                    {progress < totalSeconds ? `${progress} seconds elapsed...` : 'Finalizing report...'}
                </p>
                <p className="mt-4 text-sm text-gray-700">
                    You can also track status at{" "}
                    <a 
                        href="https://apilabz.com/api-labs/dashboard" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:text-blue-700 underline"
                    >
                        API Labz Dashboard
                    </a>
                </p>
            </div>
        </div>
    );
};

export default ProgressDialog;